@if (pageData) {

  <div class="pb-5">
    <form #productForm="ngForm" (ngSubmit)="savePage()">

      <!-- Title -->
      <app-cards-basic title="{{ 'COMMON.title' | translate }}">
        @for(lang of _languageService.supportedLangs; track lang){
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>{{ 'COMMON.title_' + lang | translate }}</mat-label>
            <input matInput
                   required
                   [(ngModel)]="pageData.translations[lang].title"
                   [readonly]="isDefaultPage"
                   name="productTitle_{{ lang }}">
          </mat-form-field>
        }
      </app-cards-basic>

      <!-- Permalink -->
      <app-cards-basic title="Permalink">
        @for(lang of _languageService.supportedLangs; track lang){
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Permalink ({{ 'COMMON.' + lang | translate }})</mat-label>
            <input matInput
                   required
                   [(ngModel)]="pageData.translations[lang].slug"
                   [readonly]="isDefaultPage"
                   name="slug_{{ lang }}"
                   [appSlugTransform]="pageData.translations[lang].title">
          </mat-form-field>
        }
      </app-cards-basic>

      <!-- Access -->
      <app-cards-basic title="{{ 'COMMON.access' | translate }}">
        <mat-checkbox [(ngModel)]="pageData.is_public" name="isPublic" [disabled]="isDefaultPage">
          {{ 'PAGES.is_public' | translate }}
        </mat-checkbox>
        <br>
        <mat-checkbox [(ngModel)]="pageData.is_downloadable" name="isDownloadable">
          {{ 'PAGES.is_downloadable' | translate }}
        </mat-checkbox>
      </app-cards-basic>
    </form>

    <!-- Actions -->
    <button mat-button
            color="primary"
            type="button"
            (click)="cancel()"
            class="bp-button">
      {{ 'ACTIONS.cancel' | translate }}
    </button>
    <button mat-flat-button
            color="primary"
            [disabled]="!productForm.valid"
            (click)="savePage()"
            class="bp-button">
      {{ 'ACTIONS.save' | translate }}
    </button>
  </div>
}
